import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useSnackbar } from 'notistack'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import line from '../../public/images/line.png'
import Layout from '../../src/components/General/Layout'
import RegisterForm from '../../src/components/Forms/RegisterForm'
import cleanup from '../../src/helpers/cleanup'
import Register from '../../src/services/network/Requests/Register'
import { Authenticate } from '../../src/services/Auth'
import useContactForm from '../../src/components/Hooks/useContactForm'
import { Box } from '@material-ui/core'
import Image from 'next/image'
import ContactBand from '../../src/components/PropertyPage/ContactBand'
import DynamicMap from '../../src/components/Map/DynamicMap'
import clsx from 'clsx'

const AUTH_CALLBACK = 'https://rasti.ca/auth'
const GOOGLE_AUTH = 'https://mss.rasti.ca/v1/auth/google'

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        height: '80vh',
        backgroundColor: theme.palette.secondary.main,
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(5, 0),
            height: 'fit-content',
        },
    },
    container: {
        paddingTop: theme.spacing(2),
    },
    title: {
        color: '#ffff',
        lineHeight: '1.5em',
    },
    subTitle: {
        fontWeight: theme.typography.fontWeightRegular,
        paddingBottom: theme.spacing(5),
    },
    helper: {
        marginTop: theme.spacing(4),
    },
    buttons: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    contactInfo: {
        backgroundColor: '#fff',
        height: '60vh',
        padding: theme.spacing(10, 0),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'end',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
        },
    },
    Contact: {
        textTransform: 'uppercase',
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightRegular,
        letterSpacing: '0.1em',
        marginLeft: theme.spacing(2),
        verticalAlign: 'super',
    },
    number: {
        color: theme.palette.primary.light,
        letterSpacing: '0.07em',
        marginTop: theme.spacing(2.5),
    },
    office: {
        margin: theme.spacing(2, 0, 0, 0),
    },
    map: {
        margin: '0px',
        [theme.breakpoints.down('sm')]: {
            margin: 0,
        },
    },
}))

const RegisterPage = () => {
    const classes = useStyles()
    const { enqueueSnackbar: snackbar } = useSnackbar()
    const router = useRouter()
    const submitContact = useContactForm(
        'register',
        'rasti.ca/auth/register',
        true
    )

    const register = async (values, actions) => {
        actions.setSubmitting(true)

        await submitContact(cleanup(values))
        const response = await Register(cleanup(values))
        if (response.success) {
            Authenticate(response.token, response.user)

            snackbar(`Welcome ${response.user.first_name}!`, {
                variant: 'success',
            })

            window.location = router.query.next ? router.query.next : '/account'
        } else {
            snackbar(response.error, { variant: 'error' })
        }

        actions.setSubmitting(false)
    }

    const redirect2Google = () =>
        (window.location = `${GOOGLE_AUTH}?redirect_after=${AUTH_CALLBACK}`)

    return (
        <Layout>
            <Head>
                <title>
                    Register | Mase Rasti Team - Your trusted realtor!
                </title>
                <meta
                    name="description"
                    content="Register today and receive exclusive access to MLS & Off-Market Listings"
                />
            </Head>
            <div className={classes.root}>
                <Container className={classes.container}>
                    <Grid container alignItems="center">
                        <Grid item xs={12} md={12}>
                            <Typography
                                variant="h1"
                                color="primary"
                                className={classes.title}
                                align="center"
                            >
                                Register
                            </Typography>
                            <Typography
                                variant="body1"
                                color="primary"
                                className={classes.subTitle}
                                align="center"
                            >
                                Please fill in the form below
                            </Typography>
                            <RegisterForm
                                onSubmit={register}
                                onGooglePressed={redirect2Google}
                            />
                            {/* <Hidden mdUp implementation="js">
                                <div className={classes.buttons}>
                                    <Link
                                        href={`/auth/login${
                                            router.query.next
                                                ? `?next=${router.query.next}`
                                                : ''
                                        }`}
                                    >
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                        >
                                            Sign In
                                        </Button>
                                    </Link>
                                </div>
                            </Hidden>
                            <Hidden smDown implementation="js">
                                <Typography
                                    variant="body2"
                                    color="textPrimary"
                                    className={classes.helper}
                                    align="center"
                                >
                                    Already have an account?{' '}
                                    <Link
                                        href={`/auth/login${
                                            router.query.next
                                                ? `?next=${router.query.next}`
                                                : ''
                                        }`}
                                    >
                                        <Typography
                                            variant="h6"
                                            color="primary"
                                        >
                                            <b>Sign In</b>
                                        </Typography>
                                    </Link>
                                </Typography>
                            </Hidden> */}
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <Box className={classes.contactInfo}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid sm={12} md={6}>
                            <Image src={line} height={25} width={4} />
                            <Typography
                                variant="caption"
                                className={classes.Contact}
                            >
                                Contact Info
                            </Typography>
                            <Typography variant="h4">
                                170 Merton Street, Toronto <br /> ON M4S 1A1
                            </Typography>
                            <Typography
                                variant="h4"
                                className={clsx('mercury', classes.number)}
                            >
                                +1 (416) 800 4694
                            </Typography>
                        </Grid>
                        <Grid sm={12} md={6}>
                            <Typography variant="body1">
                                At Bayshire Realty, our mission is to improve
                                the lives of our clients by enhancing the
                                experience of purchasing and selling real estate
                                for investment purposes.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box>
                <Office
                    location={{
                        latitude: 43.6974438,
                        longitude: -79.3908573,
                    }}
                />
            </Box>
            <ContactBand />
        </Layout>
    )
}

export default RegisterPage

const Office = ({ location }) => {
    const classes = useStyles()

    return (
        <div className={classes.office}>
            <div className={classes.details}>
                <div className={classes.map}>
                    <DynamicMap
                        height="50vh"
                        default_satellite={false}
                        {...location}
                        marker={location}
                    />
                </div>
            </div>
        </div>
    )
}
